export class RequestData {
    Data: string;
    User: string;
    constructor(_Data: string) {
      this.Data = _Data;
      this.User = (JSON.parse(localStorage.getItem("ResponseData")) != null ? JSON.parse(localStorage.getItem("ResponseData")).mail : "");
    }
  }
  